import { Controller, Module } from 'cerebral'
import Devtools from 'cerebral/devtools'
import FormsProvider from '@cerebral/forms'
import HttpProvider from '@cerebral/http'
import getURL from 'utils/getURL'
import { Shortcuts } from 'modules/Shortcuts'
import Media from 'modules/Media'
import Node from 'modules/Node'
import App from 'modules/App'
import Startpage from 'modules/Startpage'
import Basket from 'modules/Basket'
import Socket from 'modules/Socket'
import OrderHistory from 'modules/OrderHistory'
import GraphQLProvider from 'providers/GraphQLProvider'
import UuidProvider from 'providers/UuidProvider'
import TranslationProvider from 'providers/TranslationProvider'
import StorageModule from '@cerebral/storage'
import rules from 'utils/rules'
import handleError from 'modules/App/chains/handleError'
import isObject from './utils/isObject'
import functionDetails from './utils/functionDetails'

import 'polyfills/objectEntries'
import 'polyfills/findIndex'

function getUrlParameter(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
  var results = regex.exec(window.location.search)
  return results === null
    ? ''
    : decodeURIComponent(results[1].replace(/\+/g, ' '))
}

const token = getUrlParameter('token')
let localToken = localStorage.getItem('bmsToken')

if (token) {
  localStorage.setItem('bmsToken', token)
  localToken = token
}

const graphql = GraphQLProvider(localToken)
const uuid = UuidProvider
const forms = FormsProvider({
  rules
})
const translator = TranslationProvider()
const http = HttpProvider({
  headers: {
    'Content-Type': 'application/json; charset=UTF-8',
    Accept: 'application/json',
    token: localToken
  }
})

const app = Module({
  modules: {
    app: App,
    startPage: Startpage,
    media: Media,
    node: Node,
    basket: Basket,
    socket: Socket,
    shortcut: Shortcuts([
      {
        commands: ['esc'],
        trigger: 'media.onEscapeDown'
      },
      {
        commands: ['command+a', 'ctrl+a'],
        trigger: 'media.selectAllFilesInState'
      },
      {
        commands: ['command+backspace', 'ctrl+d'],
        trigger: 'media.askDeleteFiles'
      },
      {
        commands: ['alt', 'ctrl', 'command', 'shift'],
        trigger: 'media.modifierKeyDown'
      },
      {
        commands: ['alt', 'ctrl', 'command', 'shift'],
        trigger: 'media.modifierKeyUp',
        event: 'keyup'
      }
    ]),
    storage: StorageModule({
      target: localStorage,
      sync: {
        showStartPage: 'startPage.show',
        unit: 'basket.unit',
        hasAgreedOnTerms: 'app.hasAgreedOnTerms',
        sharedUUID: 'shared.uuid'
      },
      prefix: 'bms'
    }),
    orderHistory: OrderHistory
  },
  catch: [[Error, handleError]],
  providers: {
    uuid,
    forms,
    graphql,
    translator,
    http
  }
})

const controller = Controller(app, {
  devtools:
    process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'test'
      ? null
      : Devtools({
          host: 'localhost:8585',
          preventExternalMutations: false,
          allowedTypes: [File]
        })
})

controller.on('functionStart', (execution, f, payload) => {
  if (execution.name !== 'catch') {
    functionDetails(execution, f, payload)
  }
})

const startSocket = websocketServerLocation => {
  const ws = new WebSocket(websocketServerLocation)
  ws.onopen = evt => {
    console.info('Websocket connected')
  }
  ws.onmessage = evt => {
    try {
      const payload = JSON.parse(evt.data)
      if (isObject(payload)) {
        controller.getSignal('socket.eventRecieved')({
          payload
        })
      }
    } catch (e) {
      controller.getSignal('app.handleError')({
        error: e
      })
    }
  }
  ws.onclose = () => {
    console.warn('Socket closed')
    // Try to reconnect in 5 seconds
    setTimeout(() => {
      startSocket(websocketServerLocation)
    }, 5000)
  }
}

startSocket(getURL().replace(/^http(s?)(.*)/, 'ws$1$2/ws'))

export default controller



// WEBPACK FOOTER //
// ./src/controller.js